import { Component } from 'react'
import { Code, CodeableConcepts, Activities, Period } from '../helpers'
import { FcPlanner } from 'react-icons/fc'
import moment from 'moment'

import './resource.css'

class CarePlan extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><FcPlanner /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcepts(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.title && 'Title'}</div>
                        <div className='Res-Title'>{this.props.resource.title && this.props.resource.title}</div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.intent && 'Intent'}</div>
                            <div className='Res-Title'>{this.props.resource.intent && Code(this.props.resource.intent)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.created && 'Created'}</div>
                        <div className='Res-Title'>{this.props.resource.created && moment(this.props.resource.created).format('lll')}</div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.period && 'Period'}</div>
                        <div className='Res-Title'>{this.props.resource.period && Period(this.props.resource.period)}</div>
                    </div>
                    {this.props.resource.activity && <div className='Res-Row'>{Activities(this.props.resource.activity)}</div>}
                </div>
            }
        </div></div>
    }
}

export default CarePlan